export const HEADER_SIDEBAR = 'InfoPoint Software'
export const TOKEN_KEY = '@dashboard/infopoint/auth'
